module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-2379436c!./packages/dof-bottom-bar/diablo.css
// module id = 442
// module chunks = 0 1